export const SITE_PICKER_HEADER = 'School'
